import { POST } from "../APiHelper/API"


export const getConversationForFixtureId = (fixture_id, onSuccess, onError) => {
    const data = {
        fixture_id: fixture_id
    }
    POST("/api/v1/conversations/conversation_for_fixture", data, onSuccess, onError)
}